/* cSpell:ignore fingerprintjs */
/*global BMap */
import {
    browserInfo,
    getAnimationEvent,
} from "@/utils/browserHandle";

import { myFingerprint } from "@/config/fingerprintjs";

export const myConst = {
    appName: 'Parking', // 首字母大写
    city: '株洲', // 判断是否在定位城市
    cacheTime: 1 * 60 * 60 * 1000, // 本地缓存最大时间 体现在 marker 在地图上的定位
    loc: {
        watchCycle: 30 * 1000,
        timeout: 5 * 1000,
        maximumAge: 60 * 1000, // 可返还的最大定位年龄 （1分钟内的都行）
    },
    defaultLoc: {
        lat: 27.833725,
        lng: 113.1404,
    },
    minPinDis: 100, // 移动地图 重新 pin marker 的最小距离
    maxShowInMap: browserInfo.versions.mobile ? 30 : 100, // marker 同时最大显示数量
    updateTimeout: 60 * 1000, // marker 点缓存最大时间 体现在 marker 上面的实时数据（数量）
    HIDE_MARKER_TEXT_LEVEL: 16,
    // API_URL: '//api.zhuzhou.city/parking',
    API_URL: '/api/',
    CDN_SERVER: '//cdn.bike.zhuzhou.city',
    fingerprint: myFingerprint(),
    isMobile: browserInfo.versions.mobile,
    mEvent: browserInfo.versions.mobile ? 'touchend' : 'click',
    animationEvent: getAnimationEvent(),
    markerHtml: `
         <div class="marker_icon bg {{res}} {{selected}}" id="markerId_{{id}}_markerId" data-type="{{type}}">
            <img class="topImg" src="{{imgBg}}" alt="cover" />
            <span class="topText use">{{uCount}}</span>
            <span class="topText empty">{{eCount}}</span>
            <div class="title marker_bottom">{{name}}</div>
        </div>`,
    infoHtml: `
        <div id="infoBox">
            <div class="top">
                <a id="infoBox_a" href="{{url}}" target="_blank">
                    <img id="infoBox_img" src="./static/img/pano_default.png" alt="pano_default"/>
                </a>
            </div>
            <div class="bottom">
                <div class="text">
                    <p id="infoBox_name" class="name mdui-typo-title"></p>
                    <div id="infoBox_info" class="infos mdui-typo"></div>
                    <div class="numWrap">
                        <p class="num empty"><span class="title">空位</span><span id="infoBox_empty" class="loading">-</span></p>
                        <p class="num use"><span class="title">使用</span><span class="loading"><span id="infoBox_use">-</span></span></p>
                        <p class="num total"><span class="title">总计</span><span class="loading"></span><span id="infoBox_total">-</span></p>
                        <p class="num tel"><span class="title">☎️</span><span class="loading" id="infoBox_tel"><a href="tel:-">-</a></span></p>
                    </div>
                </div>
                <div id="sjx_down"></div>
            </div>
        </div>`,
    infoInfoHtml: `
            <div class="info">
                <kbd class="title">{{title}}</kbd>
                <p class="content">{{content}}</p>
            </div>
        `,
};

if (location.host.startsWith('localhost')) {
    Object.assign(myConst, {
        cacheTime: 0,
        API_URL: '/api/',
        // API_URL: 'http://127.0.0.1:9999/parking/',
        maxShowInMap: 10,
    });
}



export const myFn = {
    $$: window.mdui.JQ,
    init: '', //  map组件中赋值 函数
    pin: '', //  map组件中赋值 函数
};

export const myMap = {
    map: {}, // map initMap 赋值
    geolocation: {}, // map getMyLocInit 赋值
    infoBox: null,
    infoBoxState: {
        openMarker: null,// openMarker -> 当前 marker 自己挂到对象上
        lastOpen: 0, // 最近一次打开 infoBox 时间 用来在 pin 里面判断要不要关闭 infoBox
    },
};

/**
 * myMap.infoBox 说明
 *
 * map initMap 赋值为 InfoBox 类
 * _isOpen: false, // _isOpen -> 是否打开  infoBox自有属性
 */


window.myMap = myMap;